import {
  Box,
  Center,
  Heading, useColorModeValue, useDisclosure, useMediaQuery
} from "@chakra-ui/react";
import { IFrameTestimonials } from "components/onboard-new/IFrameTestimonials";
import { useSession } from "next-auth/react";
import { useRouter } from "next/dist/client/router";
import * as React from "react";
import { useLocation } from "utils/useLocation";
import { BillingFrequency } from "../duration-switcher";
import { PlansLeaders } from "../pricing/plansLeaders";

export const Pricing = () => {
  const router = useRouter();
  const { data: session, status } = useSession() ?? {}
  const loading = status === "loading"
  const [email, setEmail] = React.useState("");
  const [billingFrequency, setBillingFrequency] = React.useState<BillingFrequency>("yearly");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isLoading, setIsLoading] = React.useState(false);
  const [isInit, setIsInit] = React.useState(false);
  const [refresh, refresher] = React.useState({});
  const initialRef = React.useRef<HTMLInputElement>(null);
  const { isFromIndia } = useLocation();
  const [isTooSmall] = useMediaQuery("(max-width: 800px)");

  React.useEffect(() => {
    if (session?.user?.uid && !isInit) {
      // setBillingFrequency(getPeriodicity(session.user));
      setIsInit(true);
    }
  }, [session]);

  const color = useColorModeValue("taplio.500", "blue.300");
  const bgTestimonial = useColorModeValue("white", "gray.800");

  return (
    <>
      <Box as="section" py="10">
        <Box
        // maxW={{ base: "xl", md: "4xl" }}
        // px={{ base: "6", md: "8" }}
        // mx="auto"
        >
          <Center>
            <Heading
              mt="4"
              textAlign="center"
              fontWeight="900"
              fontSize="46px"
              maxW="800px"
              mb={10}
            >
              <b>Manage your subscription</b>
            </Heading>
          </Center>
          {/* <SocialProof /> */}
          {/* {
          !isTooSmall && (
            <SocialProof />
          )
        } */}

          {/* <Center mt="20">
          <DurationSwitcher
            mt={{ base: "2", lg: "-6" }}
            mb="10"
            onChange={() =>
              setBillingFrequency(
                billingFrequency === "monthly" ? "yearly" : "monthly"
              )
            }
            billingFrequency={billingFrequency}
            discountOf={isFromIndia ? "40" : undefined}
          />
        </Center> */}

          <PlansLeaders
            billingFrequency={billingFrequency}
            discount={""}
            customCancelUrl="pricing"
          />

          {
            // session?.user?.data?.abTestFreeGuide && (
            //   <Center>
            //     <GiftGuide title="Included 🎁" description="Our 25+ pages Twitter Growth Guide 📕 (valued $49)" bg={mode("gray.700", "gray.700")} />
            //   </Center>
            // )
          }
        </Box>
        {/* <Box display="flex" flexDirection="column" alignItems="center">
        <Heading textAlign="center" mt={8} mb={16}>
          See what people say about us
        </Heading> */}
        {/* <Box minWidth="80%" maxWidth="1200px"> */}
        {/* <div className="shoutout-embed" data-wall="TweetHunter"></div> */}
        {/* <ShoutoutEmbed url="influentleaders"/> */}

        {/* <script type="text/javascript" src="https://testimonial.to/js/iframeResizer.min.js" dangerouslySetInnerHTML={{ __html: ``}}/> */}
        {/* <Iframe id="testimonialto-taplio-light" url={"https://embed.testimonial.to/w/taplio?theme=light&card=base"} width="100%" height="1400px"/> */}
        {/* <script type="text/javascript" dangerouslySetInnerHTML={{ __html: `iFrameResize({log: false, checkOrigin: false}, "#testimonialto-taplio-light");`}}/> */}

        {/* </Box> */}
        {/* <IframeResizer
          {...{
            src: "https://embed.testimonial.to/w/taplio?theme=light&card=base",
            log: true,
            style: {
              width: "1px",
              minWidth: "100%",
            },
          }}
        />
      </Box> */}
      </Box>
      <Box
        as="section"
        mb="50px"
        display="flex"
        flexDirection="column"
        alignItems="center"
        maxW={{ base: "xl", md: "6xl" }}
        mx="auto"
      >
        <Center mb={16}>
          <Heading
            mt="4"
            px={[0, 4]}
            textAlign="center"
            fontWeight="900" // fontSize="46px"
            maxW="500px"
            {...{
              fontFamily: "inter",
              color,
              fontSize: "2xl",
            }}
          >
            <b>Meet some of our very happy users</b>
          </Heading>
        </Center>
        <IFrameTestimonials />
      </Box>
    </>
  );
};
